<template>
  <div class="mx-3 ma-4">
    <v-card class="pa-5">
      <v-card-title>Customer Payments</v-card-title>

      <v-data-table
        :headers="headers"
        :items="payments"
        :items-per-page="10"
        :loading="loading"
        :hide-default-footer="true"
        :disable-sort="true"
        :disable-pagination="true"
      >
        <template v-slot:item="{ item, index }">
          <tr :class="index % 2 === 0 ? 'dark-row' : 'light-row'" class="custom-row">
            <td class="text-left">{{ item.receipt_no }}</td>
            <td class="text-left">{{ item.date }}</td>
            <td class="text-left">{{ item.payment_method_name }}</td>
            <td class="text-left">{{ currencyCode }}{{ formatNumber(item.amount) }}</td>
            <td class="text-left">
              <v-chip :color="item.is_confirmed ? 'success' : 'warning'" small>
                {{ item.is_confirmed ? 'Completed' : 'Pending' }}
              </v-chip>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-alert v-if="!loading && payments.length === 0" type="info" class="mt-5" outlined>
        No payments found for this customer.
      </v-alert>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");
import { CustomerService } from "@/services/customer-service.js";

export default {
  name: "CustomerPayments",
  data() {
    return {
      payments: [],
      loading: false,
      headers: [
        { text: "Payment ID", value: "receipt_no", align: "start" },
        { text: "Date", value: "date", align: "start" },
        { text: "Method", value: "payment_method_name", align: "start" },
        { text: "Amount", value: "amount", align: "start" },
        { text: "Status", value: "is_confirmed", align: "start" },
      ],
    };
  },
  computed: {
    ...mapSettingsGetters(["currencyCode"]),
  },
  mounted() {
    this.fetchPayments();
  },
  methods: {
    async fetchPayments() {
      const uuid = this.$route.params.uuid;
      this.loading = true;
      try {
        const response = await CustomerService.getCustomerReceipts(uuid);
        this.payments = response.data.data || [];
      } catch (error) {
        this.payments = [];
      } finally {
        this.loading = false;
      }
    },
    formatNumber(value) {
      return Number(value || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
.dark-row {
  background-color: #fafafa;
}
.light-row {
  background-color: #ffffff;
}
.custom-row {
  height: 60px;
  border: none;
}
</style>
